import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

export const walmartisrael: GetCustomerCopyFunc = () => {
  return {
    hideWorkLifeServicesForInternationalUser: true,
  }
}
